//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex';
import PageLoader from '@motionelements/core/src/components/ui/PageLoader.vue';
import HeroAsideWrapper from '@/components/landing/HeroAsideWrapper.vue';
import CategoryElements from './category/CategoryElements.vue';
import CategoryTopics from './category/CategoryTopics.vue';
import HeroAside from './category/HeroAside.vue';

export default {
  name: 'LandingCategoryPage',
  components: {
    CategoryElements,
    CategoryTopics,
    HeroAside,
    HeroAsideWrapper,
    PageLoader,
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    Breadcrumbs: () => import('@motionelements/core/src/components/ui/BaseBreadcrumbs.vue'),
  },
  props: {
    mediaType: { type: String, required: true },
    isLoaded: { type: Boolean, default: false },
  },
  computed: {
    ...mapState({
      currentCategory: state => state.category.categoryData,
    }),
    ...mapGetters({
      latest: 'category/latest',
      latestLoading: 'category/latestLoading',
      popular: 'category/popular',
      categoryTopics: 'category/categoryTopics',
      title: 'category/title',
      description: 'category/description',
      url: 'category/url',
    }),
    categoryId() {
      return this.$route.params.id;
    },
    backgroundImageUrl() {
      return this.$store.getters['category/backgroundImageUrl'];
    },
    backgroundImageObject() {
      if (this.backgroundImageUrl) {
        return {
          previews: { jpg: { url: this.backgroundImageUrl } },
        };
      }
      return null;
    },
    breadcrumbList() {
      const list = [];
      const mediaTypeGroup = this.mediaType;
      list.push({
        name: this.$term('mediaType', mediaTypeGroup).text(),
        link: this.$link(this.$tools.getChannelUrl(mediaTypeGroup)).url(),
      });
      list.push({
        name: this.title,
        link: this.url || this.$link(this.$route.path).url(),
      });
      return list;
    },
  },
};
